import { useNavigate, useParams } from 'react-router-dom';
import { usePaymentApiV1 } from '../../../clients/quipli-service/payment/payment-api-v1';
import { useEffect, useRef, useState } from 'react';
import { StripeConfig } from '../../../clients/quipli-service/payment/payment';
import { loadConnect, StripeConnectWrapper } from '@stripe/connect-js/pure';

export const CustomConnectOnboarding = () => {
  const { getStripeSettingsAdmin, createAccountSession, completeCustomSetup } = usePaymentApiV1();
  const { stripeAccountId } = useParams();
  const [stripeSettings, setStripeSettings] = useState<StripeConfig>();
  const [stripe, setStripe] = useState<StripeConnectWrapper>();
  const [clientSecret, setClientSecret] = useState<string>();
  const ref = useRef<HTMLDivElement>(null);
  const [initialized, setInitialized] = useState<boolean>();
  const navigate = useNavigate();

  useEffect(() => {
    if (stripeAccountId) {
      getStripeSettingsAdmin().then(setStripeSettings);
      loadConnect().then(setStripe);
      createAccountSession(stripeAccountId).then(setClientSecret);
    }
  }, [stripeAccountId]);

  useEffect(() => {
    if (stripeSettings && stripe && clientSecret && stripeAccountId && !initialized) {
      const connectInstance = stripe.initialize({
        publishableKey: stripeSettings.publishableKey,
        clientSecret,
        refreshClientSecret: () => createAccountSession(stripeAccountId),
      });
      const onboardingComponent = connectInstance.create('account-onboarding');
      if (onboardingComponent) {
        onboardingComponent.addEventListener('exit', () => {
          completeCustomSetup(stripeAccountId).then(() => navigate('/manager/quipli-pay'));
        });
        ref.current?.appendChild(onboardingComponent);
      }
      setInitialized(true);
    }
  }, [stripeSettings, stripe, clientSecret, stripeAccountId, initialized]);

  return (
    <div>
      <div ref={ref}></div>
    </div>
  );
};
